import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';
import RGBA from 'app/styles/rgbToRgbaConverter';

const { widthSmall, widthMediumExtended, widthLarge } = breakPoints;

const HeroBlockDarkWrapper = styled.section`
  label: HeroBlockDarkWrapper;

  background-color: var(--colors-black);
`;

const HeroBlockDark = styled.div`
  label: HeroBlockDark;

  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 3.75rem 0 2.5rem;

  @media (${widthSmall}) {
    padding-bottom: 3.4375rem;
  }

  @media (${widthMediumExtended}) {
    align-items: top;
    flex-direction: row;
    text-align: ${startDirection};
    padding-top: 5.25rem 0 3.875rem;
  }
`;

const PartnersImage = styled.img`
  label: PartnersImage;

  max-height: 50rem;
  object-fit: contain;

  @media (${widthMediumExtended}) {
    height: 100%;
  }
`;

const Picture = styled.picture`
  label: Picture;

  display: contents;
`;

const UpsellWrapper = styled.div`
  label: UpsellWrapper;

  color: var(--colors-white);
  margin-top: 1rem;
  margin-${startDirection}: 0;


  @media (${widthMediumExtended}) {
    max-width: 34rem;
    margin-${startDirection}: 2.25rem;
  }
`;

const TopLogo = styled.img`
  label: Image;

  max-height: 4.75rem;
  max-width: 80%;
  margin-bottom: 0.75rem;
`;

const BottomLogo = styled.img`
  label: Image;

  display: block;
  margin: 1.5rem auto 0;
  max-height: 4.75rem;

  @media (${widthMediumExtended}) {
    margin-${startDirection}: 0;
  }
`;

const Title = styled.h1`
  label: Title;

  margin-bottom: 0.75rem;

  @media (${widthLarge}) {
    max-width: 25.75rem;
  }
`;

const SubTitle = styled.h1`
  label: SubTitle;

  margin-bottom: 1rem;

  @media (${widthSmall}) {
    margin-bottom: 1.5rem;
  }
`;

const ButtonHolder = styled.div`
  label: ButtonHolder;

  margin: 0 auto 1.5rem;
  max-width: 28.625rem;

  @media (${widthMediumExtended}) {
    margin: 0 0 1.5rem;
  }
`;

const LegalText = styled.div`
  label: LegalText;

  color: ${RGBA('--colors-white', 0.6)};
`;

const PerksHolder = styled.div`
  label: PerksHolder;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem 2rem;

  @media (${widthSmall}) {
    max-width: 37.5rem;
    gap: 1.5rem 5rem;
  }

  @media (${widthLarge}) {
    width: 100%;
    max-width: 70rem;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 1rem;
  }
`;

const Styled = {
  HeroBlockDarkWrapper,
  HeroBlockDark,
  Picture,
  TopLogo,
  BottomLogo,
  PartnersImage,
  UpsellWrapper,
  Title,
  SubTitle,
  ButtonHolder,
  LegalText,
  PerksHolder,
};

export default Styled;
